import classnames from 'classnames';
import styles from './CategorySearch.scss';
import { useUtils } from '../UtilsProvider';
import React, { FC, useRef, useState } from 'react';
import { Button, TextLabel } from '@wix/wix-base-ui';
import { symbol as Symbol } from '@wix/santa-editor-symbols';

export interface CategorySearchProps {
  isScrolled: boolean;
  onQueryChange: (query: string) => void;
}

export const CategorySearch: FC<CategorySearchProps> = ({ onQueryChange, isScrolled }) => {
  const [query, setQuery] = useState<string>('');
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const { translate } = useUtils();

  const handleInputValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const startSearch = (q: string) => {
    onQueryChange?.(q);
    searchInputRef.current?.blur();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event?.key === 'Enter') {
      startSearch(query);
    }
  };

  const clearQuery = () => {
    setQuery('');
    startSearch('');
  };

  const handleWrapperClick = () => {
    searchInputRef.current?.focus();
  };

  return (
    <div
      className={classnames(styles.addPanelCategorySearch, { [styles.addPanelCategorySearchScrolled]: isScrolled })}
      data-hook="add-panel-category-search"
    >
      <div
        className={classnames(styles.addPanelCategorySearchTitle, {
          [styles.addPanelCategorySearchTitleHidden]: isScrolled,
        })}
      >
        <TextLabel value={translate('Media_Panel_Search_Media_Label')} shouldTranslate={false} />
      </div>
      <div
        onClick={handleWrapperClick}
        className={classnames(styles.searchInputWrapper, {
          [styles.searchInputWrapperFocused]: isFocused,
          [styles.searchInputWrapperWithQuery]: query !== '',
        })}
      >
        <span className={styles.searchIcon}>
          <Symbol name="media-manager-panel-search" />
        </span>
        <input
          value={query}
          placeholder={translate('Media_Panel_Search_Media_Placeholder')}
          onChange={handleInputValueChange}
          onKeyDown={handleKeyDown}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {
            // TODO: need to solve click on startSearch button when onBlur set isFocused to false.
            setTimeout(() => {
              setIsFocused(false);
            }, 150);
          }}
          ref={searchInputRef}
        />
        <div
          data-hook="add-panel-search_button_wrapper"
          className={classnames(styles.searchButtonWrapper, {
            [styles.visibleButton]: query !== '',
          })}
        >
          {isFocused ? (
            <Button onClick={() => startSearch(query)} className={classnames(styles.searchButton, 'btn')}>
              <Symbol name="media-manager-panel-arrow-right" />
            </Button>
          ) : (
            <Button onClick={clearQuery} className={classnames(styles.searchButton, 'btn', 'btn-light')}>
              <Symbol name="headerCloseButton" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
